__webpack_require__.p =(function() {
          try {
            const urlString = __system_context__.meta.url;
            const url = new URL(urlString);
            const pathname = url.pathname;
            const rootDirectoryLevel = 1;

            let numDirsProcessed = 0, index = pathname.length;
            while (numDirsProcessed !== rootDirectoryLevel && index >= 0) {
              const char = pathname[--index];
              if (char === '/') {
                numDirsProcessed++;
              }
            }

            if (numDirsProcessed !== rootDirectoryLevel) {
              throw Error(
                'rootDirectoryLevel (' +
                  rootDirectoryLevel +
                  ') is greater than the number of directories (' +
                  numDirsProcessed +
                  ') in the URL path ' +
                  urlString
              );
            }

            url.pathname = url.pathname.slice(0, index + 1);
            return url.href;
          } catch (e) {
            console.error(e)
            return '';
          }
        })();